module.exports = __webpack_public_path__ + "static/media/YM47_0.1ea5c86c.jpg";